import PreloaderSpin from './component'
export { CenteredPreloader } from './centered_preloader'

export default PreloaderSpin